<app-topbar></app-topbar>

<section class="pricing-plans">
    <!-- Bronze -->
    <div class="pricing-card bronze" (mousemove)="updateSpotlight($event, 'bronze')" (mouseleave)="clearSpotlight('bronze')">
        <div class="heading">
            <h4>BRONZE</h4>
            <p>Best for Starters</p>
        </div>
        <p class="price">
            7.5K
            <sub>/month</sub>
        </p>
        <ul class="features">
            <li><i class="fa-solid fa-check"></i> ✓ Order confirmation mail, invoice & delivery notifications</li>
            <li><i class="fa-solid fa-check"></i> ✓ WhatsApp, Mail & Message notifications</li>
            <li><i class="fa-solid fa-check"></i> ✓ Order dispatch management & monitoring</li>
            <li><i class="fa-solid fa-check"></i> ✓ 3 Courier Partner alignment</li>
            <li><i class="fa-solid fa-check"></i> ✓ Customer support on Mails</li>
            <li><i class="fa-solid fa-check"></i> ✓ Bi-Monthly Sales Monitoring</li>
            <li><i class="fa-solid fa-check"></i> ✓ OTP Based Delivery (Free)</li>
            <li><i class="fa-solid fa-check"></i> ✓ Return Pickup (2 Attempts)</li>
            <li><i class="fa-solid fa-check"></i> ✓ Customer Returns Module (Chargeable)</li>
            <li><i class="fa-solid fa-check"></i> ✓ Monthly Reviews & Ticket resolution (2 days)</li>
            <li><i class="fa-solid fa-check"></i> ✓ Content & Creative Updates</li>
            <li><i class="fa-solid fa-check"></i> ✓ New listing addition in ERP & Inventory management</li>
        </ul>
        <button class="cta-btn" (click)="rounteToDemo()">SELECT</button>
    </div>

    <!-- Silver -->
    <div class="pricing-card silver" (mousemove)="updateSpotlight($event, 'silver')" (mouseleave)="clearSpotlight('silver')">
        <div class="heading">
            <h4>SILVER</h4>
            <p>For Growing Businesses</p>
        </div>
        <p class="price" style="color: rgba(0, 0, 0, 0.714);">
            15K
            <sub>/month</sub>
        </p>
        <ul class="features">
            <li><i class="fa-solid fa-check"></i> ✓ Order dispatch management & monitoring</li>
            <li><i class="fa-solid fa-check"></i> ✓ 2 Courier Partner alignment</li>
            <li><i class="fa-solid fa-check"></i> ✓ Return Pickup (Single Attempt)</li>
            <li><i class="fa-solid fa-check"></i> ✓ OTP Based Delivery (Chargeable)</li>
            <li><i class="fa-solid fa-check"></i> ✓ Weekly Reviews & Ticket resolution (1 day)</li>
            <li><i class="fa-solid fa-check"></i> ✓ Basic SEO & Social Media integration</li>
            <li><i class="fa-solid fa-check"></i> ✓ Website maintenance & optimization</li>
            <li><i class="fa-solid fa-check"></i> ✓ 500 Bulk email support</li>
            <li><i class="fa-solid fa-check"></i> ✓ Discounts & Coupons creation</li>
            <li><i class="fa-solid fa-check"></i> ✓ Improve Site Speed & Structure</li>
            <li><i class="fa-solid fa-check"></i> ✓ New product listing in ERP & Inventory management</li>
            <li><i class="fa-solid fa-check"></i> ✓ Creative Update & Content replacement</li>
        </ul>
        <button class="cta-btn" (click)="rounteToDemo()">SELECT</button>
    </div>

    <!-- Gold -->
    <div class="pricing-card gold" (mousemove)="updateSpotlight($event, 'gold')" (mouseleave)="clearSpotlight('gold')">
        <div class="heading">
            <h4>GOLD</h4>
            <p>Advanced Features</p>
        </div>
        <p class="price">
            22K
            <sub>/month</sub>
        </p>
        <ul class="features">
            <li><i class="fa-solid fa-check"></i> ✓ Multiple Courier Partner alignment</li>
            <li><i class="fa-solid fa-check"></i> ✓ Customer support on Mails & WhatsApp</li>
            <li><i class="fa-solid fa-check"></i> ✓ Weekly Sales Monitoring & Strategising</li>
            <li><i class="fa-solid fa-check"></i> ✓ Return Pickup (3 Attempts)</li>
            <li><i class="fa-solid fa-check"></i> ✓ Customer Returns Module (Free after 3 months)</li>
            <li><i class="fa-solid fa-check"></i> ✓ Dedicated POC & Weekly Reviews</li>
            <li><i class="fa-solid fa-check"></i> ✓ Full SEO + Social Media support</li>
            <li><i class="fa-solid fa-check"></i> ✓ Optimize Titles, Meta & Product Pages</li>
            <li><i class="fa-solid fa-check"></i> ✓ 1000 Bulk email support</li>
            <li><i class="fa-solid fa-check"></i> ✓ Discounts, Coupons & Order Tracking</li>
            <li><i class="fa-solid fa-check"></i> ✓ Mobile Optimization & Local SEO</li>
            <li><i class="fa-solid fa-check"></i> ✓ Shopify Product Listings & Offers (BOGO)</li>
            <li><i class="fa-solid fa-check"></i> ✓ Customer API Creation & Plugins Support</li>
        </ul>
        <button class="cta-btn" (click)="rounteToDemo()">SELECT</button>
    </div>
</section>
<app-footer></app-footer>